/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-09-24 09:29:54
 * @LastEditors: hongye
 * @LastEditTime: 2025-11-17 14:33:21
 * @Description: file content
 */
// 版本监控
import { Modal } from 'ant-design-vue'
import { lang } from '@/utils'
let time:any = null
// 标记 MessageBox 弹窗是否存在
let isMessageBoxVisible = false;
export const versionCheck = async () => {
  const timestamp = new Date().getTime()
  //import.meta.env.MODE 获取的是开发还是生产版本的
  console.log(`import.meta.env.MODE: ${import.meta.env.MODE}`)
  if (import.meta.env.MODE.includes('development')) return;
  if (isMessageBoxVisible) { // 如果 MessageBox 弹窗已存在，则不执行后续代码
    return;
  }
  fetch(`/version.json?t=${timestamp}`).then(res => res.json()).then(resp => {
    if (process.env.VITE__APP_VERSION__ !== resp.version) {
      isMessageBoxVisible = true;
      Modal.confirm({
        title: lang('发现新版本'),
        content: lang('检测到最新版本，刷新后立即使用...'),
        okText: lang('立即更新'),
        onOk() {
          window.location.reload()
          isMessageBoxVisible = false; // 重置 MessageBox 弹窗状态
        }
      })
    }
  });
};
export function getVersion() {
  document.addEventListener('visibilitychange', handleVisibilityChange);
}
// 处理页面可见性变化的函数
function handleVisibilityChange() {
  if (document.visibilityState === 'visible') {
    versionCheck();
  } else {
    time && clearInterval(time)
  }
}
